<template>
    <div class="column-layout">
        <div class="left-column fl" style="border: 1px solid #f4f4f4;">
            <swb-servc-cat-tree :enableSearch="enableSearch" :isClickEvent="isClickEvent" @notity-change="checkCatChange($event)"></swb-servc-cat-tree>
        </div>
        <div class="right-column fl" style="border: 1px solid #f4f4f4">
            <div class="switch-list">
                <el-radio-group v-model="brandId" v-for="row in catBrandList">
                    <div class="switch-item">
                        <el-radio :label="row.id">{{row.servcBrand.name}}</el-radio>
                    </div>
                </el-radio-group>
            </div>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import servcCateggApi from '../../api/servcCateg'
    //
    import SwbServcCatTree from '../categ/ServcCatTree.vue';
    Vue.regist(SwbServcCatTree);
    //
    export default {
        name: 'swb-servc-catg-and-brand-select',
        desc: '采购入选商品-保存',
        data: function () {
            return {
                enableSearch: true,
                isClickEvent: true,
                cat: {},
                brandId: null,
                catBrandList: []
            }
        },
        created: function () {
        },
        methods: {
            handleCheckedCitiesChange: function (values) {
            },
            checkCatChange: function (eventDate) {
                //
                this.cat = eventDate;
                this.getCatBrandList(eventDate.id);
            },
            getCatBrandList: function (catId) {
                let self = this;
                let postData = {};
                postData.catId = catId;
                servcCateggApi.getServcCatBrandListByCatId(postData, function (result) {
                    if(result.type === "info") {
                        self.catBrandList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                if(!Utils.isNoB(self.brandId)) {
                    let cat = self.cat;
                    let catBrand = {};
                    let catBrandList = self.catBrandList || [];
                    catBrandList.forEach(function (item) {
                        if(self.brandId == item.id) {
                            catBrand = item;
                        }
                    });
                    let postData = {
                        cat: cat,
                        catBrand: catBrand
                    };
                    result.type = "info";
                    result.data = postData;
                } else {
                    result.type = "warn";
                    result.message = "请选择对应的信息";
                }
                return result;
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/ServcCategAndBrandSelect.vue